import { render, staticRenderFns } from "./IntegrationsListEmpty.vue?vue&type=template&id=8e78319e&scoped=true&"
import script from "./IntegrationsListEmpty.vue?vue&type=script&lang=js&"
export * from "./IntegrationsListEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e78319e",
  null
  
)

/* custom blocks */
import block0 from "./IntegrationsListEmpty.vue?vue&type=custom&index=0&blockType=i18n&locale=ru&lang=yml"
if (typeof block0 === 'function') block0(component)
import block1 from "./IntegrationsListEmpty.vue?vue&type=custom&index=1&blockType=i18n&locale=en&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
